import type { SVGProps } from 'react';
const SvgIconBill = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M11 6.25a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0m.75 4.25a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5M10 6.25a.75.75 0 0 0-.75-.75h-2a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 .75-.75M9.25 9a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1 0-1.5z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 1.514A2.25 2.25 0 0 0 .5 3.75v5c0 .966.784 1.75 1.75 1.75h1q.127 0 .25-.018V12A2.5 2.5 0 0 0 6 14.5h7a2.5 2.5 0 0 0 2.5-2.5V4.5a3 3 0 0 0-3-3H3zM5 12a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V4.5A1.5 1.5 0 0 0 12.5 3H5zM3.5 3.75a.75.75 0 0 0-1.5 0v5c0 .138.112.25.25.25h1a.25.25 0 0 0 .25-.25z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconBill;
